/**
 * 支持的方法列表及说明，所有方法的参数与原生插件完全一致：
 * 
 * 【基础服务管理】
 * connectService - 连接 TMS 服务，必须先调用，参数：`{}`
 * disconnectService - 断开 TMS 服务，参数：`{}`
 * 
 * 【设备信息模块】
 * getSerialNo - 获取设备序列号，参数：`{}`
 * getManufacture - 获取设备厂商，返回Sunmi，参数：`{}`
 * getModel - 获取Sunmi设备型号，参数：`{}`
 * getAndroidOSVersion - 获取Android版本，参数：`{}`
 * getMac - 获取MAC地址，参数：`{}`
 * getSDKVersion - 获取SDK版本，参数：`{}`
 * getIMEIBySlotIndex - 根据卡槽索引获取IMEI，参数：`{ slotIndex: 0 }`
 * getAndroidKernelVersion - 获取内核版本，参数：`{}`
 * getROMVersion - 获取ROM版本，参数：`{}`
 * getFirmwareVersion - 获取固件版本，参数：`{}`
 * getHardwareVersion - 获取硬件版本，参数：`{}`
 * getMemoryOccupation - 获取已用内存(字节)，参数：`{}`
 * getSystemProperty - 获取系统属性值，参数：`{ key: "" }`
 * getIMSIBySlotIndex - 根据卡槽索引获取IMSI，参数：`{ slotIndex: 0 }`
 * getFullICCID - 获取ICCID，参数：`{ slotIndex: 0 }`
 * getSunmiOsVersion - 获取Sunmi OS版本，参数：`{}`
 * getIpAddresses - 获取IP列表(逗号分隔)，参数：`{}`
 * getDeviceBluetoothMacAddress - 获取蓝牙MAC，参数：`{}`
 * isFinancialDevice - 是否是金融设备，返回"true"/"false"，参数：`{}`
 * verifyCrp - 校验资源包，参数：`{ filePath }`
 * installCrp - 安装资源包，参数：`{ filePath }`
 * getCrpType - 获取资源包类型，参数：`{ filePath }`
 * getCrpVersion - 获取资源包版本，参数：`{ crpType }`
 * getGmsFlag - 获取GMS标志，参数：`{}`
 * isInnerScannerSupported - 是否支持内置扫码器，参数：`{}`
 * isInnerPrinterSupported - 是否支持内置打印机，参数：`{}`
 * getSystemBuildDisplayId - 获取Build显示ID，参数：`{}`
 * getIMSI - 获取默认卡IMSI，参数：`{}`
 * getIMEI - 获取默认卡IMEI，参数：`{}`
 * getBrand - 获取设备品牌，参数：`{}`
 * 
 * 【设备管理模块】
 * powerReboot - 重启设备，参数：`{}`
 * shutdown - 关机，参数：`{}`
 * factoryReset - 恢复出厂设置，参数：`{}`
 * setScreenBrightness - 设置屏幕亮度，参数：`{ brightness: 128 }`（取值0~255）
 * setScreenTimeout - 设置屏幕超时，参数：`{ timeout: 60000 }`（单位毫秒）
 * getScreenBrightness - 获取屏幕亮度值，参数：`{}`
 * enableWIFI - WiFi开关，参数：`{ enable: true }`
 * enableBluetooth - 蓝牙开关，参数：`{ enable: true }`
 * enableLocation - 定位开关，参数：`{ enable: true }`
 * setSystemTime - 设置系统时间，参数：`{ second, minute, hour, day, month, year }`
 * setTimeZone - 设置时区，参数：`{ timeZone: "GMT+08:00" }`
 * toSleep - 休眠设备，参数：`{}`
 * toWakeUp - 唤醒设备，参数：`{}`
 * setBootAnimation - 设置开机动画，参数：`{ filePath }`
 * setCustomKeyFunction - 自定义按键功能，参数：`{ key, type, value }`
 * setPowerButtonEnabled - 设置电源键可用性，参数：`{ enabled }`
 * isPowerButtonEnabled - 获取电源键状态，参数：`{}`
 * setWallpaper - 设置壁纸，参数：`{ filePath }`
 * setBrightnessMode - 设置亮度模式，参数：`{ mode }`
 * getMinimumScreenBrightnessSetting - 获取最小亮度设置，参数：`{}`
 * getMaximumScreenBrightnessSetting - 获取最大亮度设置，参数：`{}`
 * setDeviceOwner - 设置设备所有者，参数：`{ packageName, classFullPathName }`
 * clearDeviceOwner - 清除设备所有者，参数：`{}`
 * switchBTModuleEnable - 蓝牙模块开关，参数：`{ enable }`
 * isBTModuleEnabled - 获取蓝牙模块状态，参数：`{}`
 * enableAutoTime - 自动时间开关，参数：`{ enable: true }`
 * enableAutoTimeZone - 自动时区开关，参数：`{ enable: true }`
 * set24Hour - 设置24小时制，参数：`{ is24Hour }`
 * setAirplaneMode - 设置飞行模式，参数：`{ open }`
 * setPhysicKeyEnabled - 物理键开关，参数：`{ type, enable }`
 * getPhysicKeyEnabled - 获取物理键状态，参数：`{ type }`
 * enableGPS - GPS开关，参数：`{ isEnable }`
 * enableNFC - NFC开关，参数：`{ enable }`
 * 
 * 【软件管理模块】
 * installAppV2 - 安装APK（有回调），参数：`{ apkPath, autoStart }`
 * uninstallApp - 卸载应用，参数：`{ packageName }`
 * killApp - 强制停止应用，参数：`{ packageName }`
 * setAppEnabled - 禁用/启用应用，参数：`{ packageName, enabled }`
 * restartApp - 重启应用，参数：`{ packageName }`
 * setBatteryOptimizationWhitelist - 设置电池优化白名单，参数：`{ whitelist }`
 * grantAppPermissions - 授予应用权限，参数：`{ packageName, permissions }`
 * getRequestPermissions - 获取权限列表，参数：`{ packageName }`
 * allowAlertWindowPermission - 授予悬浮窗权限，参数：`{ packageName }`
 * prohibitUninstall - 禁止/允许卸载应用，参数：`{ packageName, allowUninstall }`
 * getProhibitUninstallList - 获取禁止卸载列表，参数：`{}`
 * enableAutoStartApp - 自启动功能开关，参数：`{ enable: true }`
 * isAutoStartAppEnabled - 获取自启动功能状态，参数：`{}`
 * setAutoStartApp - 设置自启动应用，参数：`{ packageName }`
 * getAutoStartApp - 获取自启动应用，参数：`{}`
 * clearAutoStartApp - 清空自启动应用，参数：`{}`
 * isForeground - 应用是否在前台，参数：`{ packageName }`
 * addAppToCommonAppLockList - 添加到应用锁，参数：`{ packageNames, type, password }`
 * removeAppFromCommonAppLockList - 从应用锁移除，参数：`{ packageNames }`
 * getCommonAppLockList - 获取应用锁列表，参数：`{}`
 * isCommonAppLock - 应用是否在应用锁中，参数：`{ packageName }`
 * installApp - 安装APK（无回调），参数：`{ apkPath }`
 * revokeAppPermission - 撤销应用权限，参数：`{ packageName, permissions }`
 * setNotificationsEnabledForPackage - 通知开关，参数：`{ packageName, enabled }`
 * clearApplicationUserDataWithResult - 清除应用用户数据，异步回调返回结果，参数：`{ packageName }`
 * deleteApplicationCacheFiles - 删除应用缓存数据，异步回调返回结果，参数：`{ packageName }`
 * 
 * 【系统管理模块】
 * updateSystem - 系统升级，参数：`{ systemPath }`
 * setDefaultLauncher - 设置默认桌面，参数：`{ packageName }`
 * setSystemLanguage - 设置系统语言，参数：`{ language: "zh-CN" }`
 * enableAdbWithResult - ADB开关，参数：`{ enable }`
 * doScreenshot - 截图，返回fd，参数：`{}`
 * enableCommonAppLock - 应用锁全局开关，参数：`{ enable }`
 * isCommonAppLockEnabled - 获取应用锁状态，参数：`{}`
 * disableSecurityPCI24HoursReboot - PCI重启开关，参数：`{ disable }`
 * set24HourRebootRegular - 定时重启，参数：`{ type, hour, minute, second }`
 * setSecurityCenterPwd - 设置安全中心密码，参数：`{ password }`
 * isAdbEnabled - 获取ADB状态，参数：`{}`
 * getSystemPackageList - 获取系统包名列表，参数：`{}`
 * 
 * 【系统UI管理模块】
 * showNatigationBar - 导航栏显隐（保留官方原始拼写），参数：`{ show }`
 * showStatusBar - 状态栏显隐，参数：`{ show }`
 * showNavigationBarBackButton - 返回键显隐，参数：`{ show }`
 * showNavigationBarHomeButton - Home键显隐，参数：`{ show }`
 * showNavigationBarRecentsButton - 多任务键显隐，参数：`{ show }`
 * enableNotificationPanel - 通知栏下拉开关，参数：`{ enable }`
 * enableNavigationBarBackButton - 返回键可用性，参数：`{ enable }`
 * isNavigationBarBackButtonEnabled - 获取返回键状态，参数：`{}`
 * enableNavigationBarHomeButton - Home键可用性，参数：`{ enable }`
 * isNavigationBarHomeButtonEnabled - 获取Home键状态，参数：`{}`
 * enableNavigationBarRecentsButton - 多任务键可用性，参数：`{ enable }`
 * isNavigationBarRecentsButtonEnabled - 获取多任务键状态，参数：`{}`
 * setAirplaneModeBarClickable - 快捷栏飞行模式可点击，参数：`{ clickable }`
 * 
 * 【设备运行时信息模块】
 * getBatteryCapacity - 获取电池容量，参数：`{}`
 * getCpuUsage - 获取CPU使用率，参数：`{}`
 * getRamTotalSize - 获取总内存(字节)，参数：`{}`
 * getRamUsedSize - 获取已用内存(字节)，参数：`{}`
 * getRomTotalSize - 获取总存储(字节)，参数：`{}`
 * getRomUsedSize - 获取已用存储(字节)，参数：`{}`
 * getGPSLocation - 获取GPS位置信息，参数：`{}`
 * getTurnOnMills - 获取开机时长(毫秒)，参数：`{}`
 * getGPSLocationWithTimeout - 实时获取GPS位置，支持超时，参数：`{ timeout: 10000 }`
 * 
 * 【网络管理模块】
 * enableMobileNetwork - 卡槽移动数据开关，参数：`{ slotIdx, enable }`
 * getDefaultDataSlotIndex - 获取默认数据卡槽，参数：`{}`
 * setDefaultDataSlotIndex - 设置默认数据卡槽，参数：`{ slotIndex }`
 * getMobileDataStatusBySlot - 获取卡槽数据状态，参数：`{ slotIndex }`
 * setMobileDataLocked - 锁定移动数据开关，参数：`{ locked }`
 * getDataRoamingEnabled - 获取数据漫游状态，参数：`{ slotIndex }`
 * setDataRoamingEnabled - 设置数据漫游开关，参数：`{ slotIndex, enable }`
 * setCustomNtpServer - 设置NTP服务器，参数：`{ server }`
 * getCustomNtpServer - 获取NTP服务器，参数：`{}`
 * forgetSavedWifi - 遗忘所有WiFi，参数：`{}`
 * resetNetworkSettings - 重置网络设置，参数：`{}`
 * installWlanCertificate - 安装WiFi证书，参数：`{ name, certData, password }`
 * turnOffWifiHotspot - 关闭热点，参数：`{}`
 * turnOnWifiHotspot - 开启热点，参数：`{ ssid, preShareKey, keyManagement }`
 * isWifiHotspotEnable - 获取热点状态，参数：`{}`
 * showWifiHotspotSettings - 跳转热点设置，参数：`{}`
 * disableWifiHotspotAndHideSettings - 禁用热点并隐藏设置，参数：`{}`
 * enableEthernet - 以太网开关，参数：`{ enable }`
 * queryTrafficUsageSummary - 流量统计，参数：`{ networkType, startTime, endTime }`
 * addNetwork - 添加WiFi配置，参数：`{ ssid, preSharedKey }`
 * updateNetwork - 更新WiFi配置，参数：`{ networkId, ssid, preSharedKey }`
 * removeNetwork - 删除WiFi配置，参数：`{ networkId }`
 * getConfiguredNetworks - 获取已保存WiFi列表，参数：`{}`
 * isActiveSlotIndex - SIM卡是否可用，参数：`{ slotIndex }`
 * getMobileDataStatus - 获取移动数据总开关，参数：`{}`
 * getTrafficOfEachApp - 获取每个应用的流量统计，参数：`{ networkType, startTime, endTime }`
 * setWifiStaticIpV2 - 设置/禁用静态IP，异步回调，参数：`{ status, ipAddr, gateway, networkPrefixLength, dns1, dns2, reconnect }`
 * connectWifiSsid - 连接已保存的WiFi，通过SSID，参数：`{ ssid }`
 * removeWifiSsid - 移除已保存的WiFi，通过SSID，参数：`{ ssid }`
 * addWifiSsidByWifiConfiguration - 通过配置对象添加WiFi，参数：`{ wifiConfig: { ssid, preSharedKey, securityType } }`
 * 
 * 【设备软件信息模块】
 * getSystemAllPackageInfo - 获取系统应用信息JSON字符串，参数：`{}`
 * 
 * 【霸屏管理模块】
 * enableKioskFunction - 打开/关闭整个霸屏功能，参数：`{ enable: true }`
 * isKioskFunctionEnabled - 获取霸屏功能的整体可用状态，参数：`{}`
 * getKioskModeStatus - 获取当前是否处于霸屏模式，参数：`{}`
 * addAppToKioskList - 将多个应用包名添加到霸屏白名单，参数：`{ packageNames: "com.a,com.b" }`
 * removeAppFromKioskList - 从霸屏白名单中移除指定应用，参数：`{ packageNames: "com.a" }`
 * getKioskAppList - 获取当前霸屏白名单中的应用列表，参数：`{}`
 * isKioskApp - 查询某个应用是否在霸屏白名单中，参数：`{ packageName: "com.xx" }`
 * setKioskPwdByType - 设置退出霸屏时需要输入的密码，参数：`{ type: 1, password: "1234" }`
 * setNavigationBarStatusForKiosk - 设置霸屏模式下导航栏的显示模式，参数：`{ status: 1 }`
 * getNavigationBarStatusForKiosk - 获取霸屏模式下导航栏的显示模式，参数：`{}`
 * hideStatusBarForKiosk - 霸屏模式下是否隐藏状态栏，参数：`{ hide: true }`
 * isStatusBarHiddenForKiosk - 获取霸屏模式下状态栏是否隐藏，参数：`{}`
 * switchKioskPwdByType - 设置退出霸屏时需要的密码类型，参数：`{ type: 2 }`
 * getSwitchKioskPwdByType - 获取退出霸屏时需要的密码类型，参数：`{}`
 * exitKioskMode - 直接退出霸屏模式，参数：`{ password: "1234" }`
 * 
 * 【证书管理模块】
 * updateCertificate - 更新应用验签证书，参数：`{ certPath: "/sdcard/cert.cer" }`
 * getCertificateInfo - 获取当前应用验签证书信息，参数：`{}`
 * getTrustedFileCertChain - 获取应用验签可信证书链信息，参数：`{}`
 * 
 * 【商米打印模块】
 * initPrinter - 初始化打印机，参数：`{}`
 * printText - 打印文本内容，参数格式参考注释
 * 
 * 【芯烨打印模块】
 * initUsb - 初始化USB打印机，参数：`{}`
 * connectUsbPrinter - 连接USB打印机，参数：`deviceName`
 * printText - 打印文本内容，参数格式参考注释
 */
const SUPPORTED_METHODS = [
  // 基础服务管理
  'connectService', 'disconnectService',
  // 设备信息模块
  'getSerialNo', 'getManufacture', 'getModel', 'getAndroidOSVersion', 'getMac', 'getSDKVersion',
  'getIMEIBySlotIndex', 'getAndroidKernelVersion', 'getROMVersion', 'getFirmwareVersion',
  'getHardwareVersion', 'getMemoryOccupation', 'getSystemProperty', 'getIMSIBySlotIndex',
  'getFullICCID', 'getSunmiOsVersion', 'getIpAddresses', 'getDeviceBluetoothMacAddress',
  'isFinancialDevice', 'verifyCrp', 'installCrp', 'getCrpType', 'getCrpVersion', 'getGmsFlag',
  'isInnerScannerSupported', 'isInnerPrinterSupported', 'getSystemBuildDisplayId', 'getIMSI',
  'getIMEI', 'getBrand',
  // 设备管理模块
  'powerReboot', 'shutdown', 'factoryReset', 'setScreenBrightness', 'setScreenTimeout',
  'getScreenBrightness', 'enableWIFI', 'enableBluetooth', 'enableLocation', 'setSystemTime',
  'setTimeZone', 'toSleep', 'toWakeUp', 'setBootAnimation', 'setCustomKeyFunction',
  'setPowerButtonEnabled', 'isPowerButtonEnabled', 'setWallpaper', 'setBrightnessMode',
  'getMinimumScreenBrightnessSetting', 'getMaximumScreenBrightnessSetting', 'setDeviceOwner',
  'clearDeviceOwner', 'switchBTModuleEnable', 'isBTModuleEnabled', 'enableAutoTime',
  'enableAutoTimeZone', 'set24Hour', 'setAirplaneMode', 'setPhysicKeyEnabled',
  'getPhysicKeyEnabled', 'enableGPS', 'enableNFC',
  // 软件管理模块
  'installAppV2', 'uninstallApp', 'killApp', 'setAppEnabled', 'restartApp',
  'setBatteryOptimizationWhitelist', 'grantAppPermissions', 'getRequestPermissions',
  'allowAlertWindowPermission', 'prohibitUninstall', 'getProhibitUninstallList',
  'enableAutoStartApp', 'isAutoStartAppEnabled', 'setAutoStartApp', 'getAutoStartApp',
  'clearAutoStartApp', 'isForeground', 'addAppToCommonAppLockList', 'removeAppFromCommonAppLockList',
  'getCommonAppLockList', 'isCommonAppLock', 'installApp', 'revokeAppPermission',
  'setNotificationsEnabledForPackage', 'clearApplicationUserDataWithResult', 'deleteApplicationCacheFiles',
  // 系统管理模块
  'updateSystem', 'setDefaultLauncher', 'setSystemLanguage', 'enableAdbWithResult', 'doScreenshot',
  'enableCommonAppLock', 'isCommonAppLockEnabled', 'disableSecurityPCI24HoursReboot',
  'set24HourRebootRegular', 'setSecurityCenterPwd', 'isAdbEnabled', 'getSystemPackageList',
  // 系统UI管理模块
  'showNatigationBar', 'showStatusBar', 'showNavigationBarBackButton', 'showNavigationBarHomeButton',
  'showNavigationBarRecentsButton', 'enableNotificationPanel', 'enableNavigationBarBackButton',
  'isNavigationBarBackButtonEnabled', 'enableNavigationBarHomeButton', 'isNavigationBarHomeButtonEnabled',
  'enableNavigationBarRecentsButton', 'isNavigationBarRecentsButtonEnabled', 'setAirplaneModeBarClickable',
  // 设备运行时信息模块
  'getBatteryCapacity', 'getCpuUsage', 'getRamTotalSize', 'getRamUsedSize', 'getRomTotalSize',
  'getRomUsedSize', 'getGPSLocation', 'getTurnOnMills', 'getGPSLocationWithTimeout',
  // 网络管理模块
  'enableMobileNetwork', 'getDefaultDataSlotIndex', 'setDefaultDataSlotIndex', 'getMobileDataStatusBySlot',
  'setMobileDataLocked', 'getDataRoamingEnabled', 'setDataRoamingEnabled', 'setCustomNtpServer',
  'getCustomNtpServer', 'forgetSavedWifi', 'resetNetworkSettings', 'installWlanCertificate',
  'turnOffWifiHotspot', 'turnOnWifiHotspot', 'isWifiHotspotEnable', 'showWifiHotspotSettings',
  'disableWifiHotspotAndHideSettings', 'enableEthernet', 'queryTrafficUsageSummary', 'addNetwork',
  'updateNetwork', 'removeNetwork', 'getConfiguredNetworks', 'isActiveSlotIndex', 'getMobileDataStatus',
  'getTrafficOfEachApp', 'setWifiStaticIpV2', 'connectWifiSsid', 'removeWifiSsid', 'addWifiSsidByWifiConfiguration',
  // 设备软件信息模块
  'getSystemAllPackageInfo',
  // 霸屏管理模块
  'enableKioskFunction', 'isKioskFunctionEnabled', 'getKioskModeStatus', 'addAppToKioskList',
  'removeAppFromKioskList', 'getKioskAppList', 'isKioskApp', 'setKioskPwdByType',
  'setNavigationBarStatusForKiosk', 'getNavigationBarStatusForKiosk', 'hideStatusBarForKiosk',
  'isStatusBarHiddenForKiosk', 'switchKioskPwdByType', 'getSwitchKioskPwdByType', 'exitKioskMode',
  // 证书管理模块
  'updateCertificate', 'getCertificateInfo', 'getTrustedFileCertChain',
  // 打印模块
  'initPrinter', 'printText',
  // 测试模块
  'testEcho'
]

// 日志开关，调试时开启可查看完整调用链路
const DEBUG = true
const log = (...args) => DEBUG && console.log('[Native-Plugin]', ...args)
const errorLog = (...args) => DEBUG && console.error('[Native-Plugin]', ...args)

// SDK状态枚举
const SDK_STATUS = {
  IDLE: 'idle',
  INITIALIZING: 'initializing',
  SUCCESS: 'success',
  FAIL: 'fail'
}

// SDK初始化器，后期可扩展多SDK
const sdkInitializers = {
  /**
   * 商米SDK初始化
   * @returns {Promise<Object>} 商米原生插件实例
   */
  sunmi: async () => {
    log('开始初始化商米SDK')
    // 校验uni环境和原生插件
    if (!uni?.requireNativePlugin) {
      throw new Error('当前环境不支持uni.requireNativePlugin，请在App端运行')
    }
    const instance = uni.requireNativePlugin('uni-sunmi-plugin')
    if (!instance) {
      throw new Error('未找到uni-sunmi-plugin插件，请确认已在manifest.json中配置并打包自定义基座')
    }

    // 商米SDK强制要求：必须先连接TMS服务才能调用其他方法
    return new Promise((resolve, reject) => {
      instance.connectService({}, (res) => {
        if (res?.code === 0) {
          log('商米SDK TMS服务连接成功', res)
          resolve(instance)
        } else {
          const errMsg = `TMS服务连接失败: ${res?.msg || '未知错误'}，错误码: ${res?.code}`
          errorLog(errMsg)
          reject(new Error(errMsg))
        }
      }, (err) => {
        const errMsg = `TMS服务连接异常: ${JSON.stringify(err)}`
        errorLog(errMsg)
        reject(new Error(errMsg))
      })
    })
  },
  /**
   * 芯烨SDK初始化
   * @returns {Promise<Object>} 芯烨原生插件实例
   */
  xinYe: async () => {
    log('开始初始化芯烨SDK')
    // 校验uni环境和原生插件
    if (!uni?.requireNativePlugin) {
      throw new Error('当前环境不支持uni.requireNativePlugin，请在App端运行')
    }
    const instance = uni.requireNativePlugin('xinye-print')
    if (!instance) {
      throw new Error('未找到xinye-print插件，请确认已在manifest.json中配置并打包自定义基座')
    }

    log('芯烨SDK初始化完成')
    return instance
  }
}

// 全局状态管理
const state = {
  // 初始化全局Promise，确保所有方法调用前初始化完成
  initPromise: null,
  // 手动初始化标记，手动init后禁用自动初始化
  manualInit: false,
  // SDK实例存储
  sdkInstances: {},
  // SDK状态存储
  sdkStatus: {},
  // SDK初始化错误存储
  sdkErrors: {}
}

/**
 * 初始化单个SDK
 * @param {string} sdkKey SDK标识
 */
async function initSingleSdk(sdkKey) {
  const initializer = sdkInitializers[sdkKey]
  if (typeof initializer !== 'function') {
    errorLog(`未找到SDK [${sdkKey}] 的初始化器`)
    return
  }

  // 避免重复初始化
  if (state.sdkStatus[sdkKey] === SDK_STATUS.INITIALIZING || state.sdkStatus[sdkKey] === SDK_STATUS.SUCCESS) {
    log(`SDK [${sdkKey}] 正在初始化/已初始化成功，跳过`)
    return
  }

  // 更新状态
  state.sdkStatus[sdkKey] = SDK_STATUS.INITIALIZING
  delete state.sdkErrors[sdkKey]
  delete state.sdkInstances[sdkKey]

  try {
    // 执行初始化
    const instance = await initializer()
    state.sdkInstances[sdkKey] = instance
    state.sdkStatus[sdkKey] = SDK_STATUS.SUCCESS
    log(`SDK [${sdkKey}] 初始化完成`)
  } catch (e) {
    state.sdkStatus[sdkKey] = SDK_STATUS.FAIL
    state.sdkErrors[sdkKey] = e
    errorLog(`SDK [${sdkKey}] 初始化失败`, e)
    throw e
  }
}

/**
 * 手动初始化SDK（优先级高于自动初始化）
 * @param {string[]} sdks 需要初始化的SDK标识列表，支持['sunmi', 'xinYe']
 * @returns {Promise<boolean>} 初始化结果
 */
async function init(sdks = []) {
  log('手动初始化SDK，列表:', sdks)
  state.manualInit = true

  // 重置全局Promise
  state.initPromise = new Promise(async (resolve) => {
    // 先断开已连接的服务，清理旧实例
    for (const sdkKey in state.sdkInstances) {
      try {
        const instance = state.sdkInstances[sdkKey]
        instance.disconnectService && instance.disconnectService({})
      } catch (e) {
        errorLog(`断开SDK [${sdkKey}] 服务失败`, e)
      }
    }

    // 清空旧状态
    state.sdkInstances = {}
    state.sdkStatus = {}
    state.sdkErrors = {}

    // 无SDK列表直接完成
    if (!Array.isArray(sdks) || sdks.length === 0) {
      log('未传入SDK列表，初始化完成')
      resolve(false)
      return
    }

    // 并行初始化所有SDK
    const initPromises = sdks.map(sdkKey => initSingleSdk(sdkKey))
    try {
      await Promise.allSettled(initPromises)
      // 检查是否有至少一个SDK初始化成功
      const hasSuccess = Object.values(state.sdkStatus).some(status => status === SDK_STATUS.SUCCESS)
      log('手动初始化完成，是否有可用SDK:', hasSuccess)
      resolve(hasSuccess)
    } catch (e) {
      errorLog('手动初始化异常', e)
      resolve(false)
    }
  })

  return state.initPromise
}

/**
 * 自动初始化：根据设备信息自动检测并初始化对应SDK
 */
async function autoInit() {
  // 已手动初始化，跳过自动初始化
  if (state.manualInit) {
    log('已执行手动初始化，跳过自动初始化')
    return
  }

  log('开始自动检测设备并初始化SDK')
  state.initPromise = new Promise((resolve) => {
    // 校验uni环境
    if (!uni?.getSystemInfo) {
      errorLog('当前环境不支持uni.getSystemInfo，自动初始化终止')
      resolve(false)
      return
    }

    uni.getSystemInfo({
      success: (res) => {
        log('获取设备信息成功', { brand: res.deviceBrand, platform: res.uniPlatform })
        const { deviceBrand, uniPlatform } = res
        // 商米设备自动初始化
        if (deviceBrand?.toLowerCase() === 'sunmi' && uniPlatform === 'app') {
          initSingleSdk('sunmi').finally(() => {
            const hasSuccess = state.sdkStatus.sunmi === SDK_STATUS.SUCCESS
            resolve(hasSuccess)
          })
        } else {
          log('非商米设备/非App环境，不初始化商米SDK')
          resolve(false)
        }
      },
      fail: (err) => {
        errorLog('获取设备信息失败，自动初始化终止', err)
        resolve(false)
      }
    })
  })

  return state.initPromise
}

/**
 * 获取SDK初始化状态
 * @param {string} sdkKey SDK标识
 * @returns {string} 状态
 */
function getSdkStatus(sdkKey) {
  return state.sdkStatus[sdkKey] || SDK_STATUS.IDLE
}

/**
 * 检查是否有可用的SDK实例
 * @returns {boolean}
 */
function hasAvailableSdk() {
  return Object.values(state.sdkStatus).some(status => status === SDK_STATUS.SUCCESS)
}

/**
 * 统一方法调用处理器
 * 兼容 回调式调用 + Promise/await 调用
 * @param {string} methodName 方法名
 * @param {Array} args 调用参数
 */
async function handleMethodCall(methodName, args) {
  // 等待全局初始化完成
  await state.initPromise

  // 检查是否有可用SDK
  if (!hasAvailableSdk()) {
    const err = new Error('无可用的SDK实例，请先初始化SDK，或确认当前设备为商米设备且已打包自定义基座')
    errorLog(`调用方法 [${methodName}] 失败:`, err.message)

    // 兼容回调：如果用户传了fail回调，触发回调
    const failCallback = args.find(arg => typeof arg === 'function') || args[1]
    if (typeof failCallback === 'function') {
      failCallback({ code: -1, msg: err.message })
      return
    }
    // 兼容Promise：抛出错误
    throw { code: -1, msg: err.message }
  }

  // 解析参数：分离 options、success回调、fail回调
  let options = {}
  let successCallback = null
  let failCallback = null

  // 处理参数格式
  if (args.length === 0) {
    options = {}
  } else if (args.length === 1) {
    if (typeof args[0] === 'function') {
      successCallback = args[0]
    } else {
      options = args[0] || {}
    }
  } else if (args.length === 2) {
    options = args[0] || {}
    if (typeof args[1] === 'function') {
      successCallback = args[1]
    }
  } else if (args.length >= 3) {
    options = args[0] || {}
    successCallback = typeof args[1] === 'function' ? args[1] : null
    failCallback = typeof args[2] === 'function' ? args[2] : null
  }

  log(`调用方法 [${methodName}]`, { options, hasSuccess: !!successCallback, hasFail: !!failCallback })

  // 遍历所有可用SDK，依次调用方法
  let lastError = null
  for (const sdkKey in state.sdkInstances) {
    // 只调用初始化成功的SDK
    if (state.sdkStatus[sdkKey] !== SDK_STATUS.SUCCESS) continue

    const instance = state.sdkInstances[sdkKey]
    // 检查SDK实例是否包含该方法
    if (typeof instance[methodName] !== 'function') {
      lastError = new Error(`SDK [${sdkKey}] 不支持方法 [${methodName}]`)
      continue
    }

    // 包装回调，兼容Promise和回调式调用
    return new Promise((resolve, reject) => {
      // 成功回调包装
      const wrappedSuccess = (res) => {
        log(`方法 [${methodName}] 调用成功`, res)
        // 触发用户传入的success回调
        if (successCallback) successCallback(res)
        // Promise resolve
        resolve(res)
      }

      // 失败回调包装
      const wrappedFail = (err) => {
        const errMsg = `方法 [${methodName}] 调用失败: ${JSON.stringify(err)}`
        errorLog(errMsg)
        lastError = err
        // 触发用户传入的fail回调
        if (failCallback) failCallback(err)
        // Promise reject
        reject(err)
      }

      // 调用原生插件方法
      try {
        instance[methodName](options, wrappedSuccess, wrappedFail)
      } catch (e) {
        const errMsg = `方法 [${methodName}] 执行异常: ${e.message}`
        errorLog(errMsg)
        wrappedFail({ code: -1, msg: errMsg, error: e })
      }
    })
  }

  // 所有SDK都调用失败
  const finalErr = lastError || new Error(`所有SDK都不支持方法 [${methodName}]`)
  errorLog(`方法 [${methodName}] 最终调用失败`, finalErr)

  // 触发fail回调
  if (failCallback) {
    failCallback({ code: -1, msg: finalErr.message, error: finalErr })
    return
  }
  // Promise reject
  throw { code: -1, msg: finalErr.message, error: finalErr }
}

// 创建代理对象，统一拦截方法调用
const nativePlugin = new Proxy({}, {
  get: (target, prop) => {
    // 暴露核心工具方法
    if (prop === 'init') return init
    if (prop === 'getSdkStatus') return getSdkStatus
    if (prop === 'hasAvailableSdk') return hasAvailableSdk
    if (prop === 'autoInit') return autoInit

    // 芯烨SDK子模块：单独封装，避免方法名冲突
    if (prop === 'xinYe') {
      return new Proxy({}, {
        get: (_, xinYeProp) => {
          // 忽略内置属性，避免console.log时触发错误
          if (typeof xinYeProp === 'symbol' || ['toJSON', 'valueOf', 'toString', 'constructor', '__proto__'].includes(xinYeProp)) {
            return Reflect.get(target, xinYeProp);
          }
          // 返回芯烨方法包装器
          return async (...args) => {
            // 自动初始化芯烨SDK（首次调用时）
            await initSingleSdk('xinYe')
            
            const instance = state.sdkInstances.xinYe
            if (!instance || state.sdkStatus.xinYe !== SDK_STATUS.SUCCESS) {
              const errMsg = '芯烨SDK初始化失败，请确认已安装xinye-print插件并在App端运行';
              errorLog(`调用芯烨方法 [${xinYeProp}] 失败:`, errMsg)
              
              // 触发用户的失败回调
              const failCb = args.filter(arg => typeof arg === 'function').pop()
              if (failCb) failCb({ code: -1, msg: errMsg })
              throw { code: -1, msg: errMsg }
            }

            // 支持传多个回调
            const params = args.filter(arg => typeof arg !== 'function');
            const callbacks = args.filter(arg => typeof arg === 'function');
            
            const successCallback = callbacks[0] || null;
            const failCallback = callbacks[1] || null;

            log(`调用芯烨方法 [${xinYeProp}]`, params, `有成功回调: ${!!successCallback}, 有失败回调: ${!!failCallback}`);

            // 调用原生方法，完全兼容芯烨SDK的原始调用方式
            return new Promise((resolve, reject) => {
              // 包装成功回调
              const wrappedSuccess = (res) => {
                log(`芯烨方法 [${xinYeProp}] 调用完成`, res)
                if (successCallback) successCallback(res)
                resolve(res)
              }

              // 包装失败回调
              const wrappedFail = (err) => {
                const errMsg = typeof err === 'object' ? (err.msg || JSON.stringify(err)) : String(err)
                errorLog(`芯烨方法 [${xinYeProp}] 执行失败/异常:`, errMsg)
                
                const errorObj = { code: -1, msg: errMsg, error: err }
                
                if (failCallback) {
                  failCallback(errorObj);
                } else if (successCallback) {
                  // 容错机制：如果用户只传了一个回调，把错误也传给它
                  successCallback(errorObj);
                }
                reject(errorObj)
              }

              const finalArgs = [...params];
              if (callbacks.length >= 1) finalArgs.push(wrappedSuccess);
              if (callbacks.length >= 2) finalArgs.push(wrappedFail);

              try {
                instance[xinYeProp](...finalArgs)
              } catch (e) {
                // 当捕获到插件内部严重崩溃时，立刻通过包装好的 fail 方法抛给外部
                wrappedFail(e)
              }
            })
          }
        }
      })
    }

    // 检查是否是支持的顶层方法（商米通用方法）
    if (!SUPPORTED_METHODS.includes(prop)) {
      errorLog(`不支持的方法: ${prop}`)
      return () => {
        const err = { code: -1, msg: `当前SDK未接入方法 [${prop}]，请检查方法名是否正确` }
        errorLog(err.msg)
        throw err
      }
    }

    // 返回顶层方法包装器
    return (...args) => handleMethodCall(prop, args)
  }
})

// 插件加载时自动执行初始化
autoInit()

// 导出统一插件对象
export default nativePlugin



//调用demo
// 1. 导入封装好的插件
// import nativePlugin from '@/utils/nativePlugin.js'
// 如需手动初始化多个SDK，优先级高于自动检测
//  nativePlugin.init(['sunmi', 'xinYe'])

// ------------------- 商米内置打印机调用demo -------------------
// const printList=ref([])
// // 2. 直接调用方法，和原生SDK的调用方式完全一样
// onMounted(()=>{
    // printOrder()
//})
// const printOrder=async()=> {
//   try {
//     // 初始化打印机，会自动等待商米的TMS服务连接成功
//     nativePlugin.initPrinter({}, (res) => {
//       if (res.code === 0) {
//         // 打印文本，同样会自动等待初始化完成
//
//       }
//     })
//   } catch (e) {
//     // 错误处理：如果商米SDK初始化失败，会自动走到这里
//     console.error('打印失败', e)
//     uni.showToast({ title: '打印失败，请检查设备', icon: 'none' })
//   }
// }
//      使用的地方里面调用这个打印
//      nativePlugin.printText({
        //     titleInfo: {
        //         title: '顾客小票',
        //         size: 20
        //     },
        //     printerId: lists.value[1],
        //     data: [
        //         {
        //             type: 'text',
        //             content: '这是一段开始文本\n\n\n\n',
        //             flex: '1',
        //             size: 16,
        //             align: 'CENTER',
        //             bold: true
        //         },
        //         {
        //             type: 'table',
        //             tableTitles: [
        //                 {
        //                     content: '商品名',
        //                     flex: '1',
        //                     size: 32,
        //                     align: 'LEFT',
        //                     bold: true,
        //                     width: 15
        //                 },
        //                 {
        //                     content: '规格',
        //                     flex: '1',
        //                     size: 32,
        //                     align: 'LEFT',
        //                     bold: true,
        //                     width: 10
        //                 },
        //                 {
        //                     content: '价格',
        //                     flex: '1',
        //                     size: 32,
        //                     align: 'LEFT',
        //                     bold: true,
        //                     width: 15
        //                 }
        //             ],
        //             tableRows: [
        //                 {
        //                     content: '奶茶'
        //                 },
        //                 {
        //                     content: '热'
        //                 },
        //                 {
        //                     content: '5.00'
        //                 },
        //                 {
        //                     content: '可乐'
        //                 },
        //                 {
        //                     content: '冷'
        //                 },
        //                 {
        //                     content: '10.00'
        //                 }
        //             ]
        //         },
        //         {
        //             type: 'text',
        //             content: '这是一段结束文本\n\n\n\n',
        //             flex: '1',
        //             size: 16,
        //             align: 'CENTER',
        //             bold: true
        //         }
        //     ]
        // }, (printRes) => {
//           console.log('打印结果', printRes)
//         })
//  调用其他方法
// async function getDeviceInfo() {
//   try {
//     // 获取设备序列号，自动等待TMS服务连接完成
//     nativePlugin.getSerialNo({}, (res) => {
//       if (res.code === 0) {
//         console.log('设备序列号：', res.data)
//       }
//     })

//     // 设置屏幕亮度，参数和原生SDK完全一致
//     nativePlugin.setScreenBrightness({ brightness: 200 }, (res) => {
//       console.log('亮度设置结果', res)
//     })
//   } catch (e) {
//     console.error('操作失败', e)
//   }
// }

// ------------------- 芯烨外接打印机调用demo -------------------
// const printOrderXinYe = async () => {
//   try {
//     // 初始化USB打印机，会自动初始化芯烨SDK
//     nativePlugin.xinYe.initUsb((res) => {
//       console.log('芯烨初始化', res);
//       if (res.code == 0 && res?.data?.length > 0) {
//         // 测试连接第一个打印机
//         nativePlugin.xinYe.connectUsbPrinter(res?.data[0]?.deviceName, (data) => {
//           console.log('链接打印机', data);
//           if (data.code == 0) {
//             // 打印小票
//             nativePlugin.xinYe.printText(
//               {
//                 titleInfo: {
//                   title: '顾客小票',
//                   size: 20
//                 },
//                 printerId: lists.value[1],
//                 data: [
//                   {
//                     type: 'text',
//                     content: '这是一段开始文本\n\n\n\n',
//                     flex: '1',
//                     size: 16,
//                     align: 'CENTER',
//                     bold: true
//                   },
//                   {
//                     type: 'table',
//                     tableTitles: [
//                       {
//                         content: '商品名',
//                         flex: '1',
//                         size: 32,
//                         align: 'LEFT',
//                         bold: true,
//                         width: 15
//                       },
//                       {
//                         content: '规格',
//                         flex: '1',
//                         size: 32,
//                         align: 'LEFT',
//                         bold: true,
//                         width: 10
//                       },
//                       {
//                         content: '价格',
//                         flex: '1',
//                         size: 32,
//                         align: 'LEFT',
//                         bold: true,
//                         width: 15
//                       }
//                     ],
//                     tableRows: [
//                       {
//                         content: '奶茶'
//                       },
//                       {
//                         content: '热'
//                       },
//                       {
//                         content: '5.00'
//                       },
//                       {
//                         content: '可乐'
//                       },
//                       {
//                         content: '冷'
//                       },
//                       {
//                         content: '10.00'
//                       }
//                     ]
//                   },
//                   {
//                     type: 'text',
//                     content: '这是一段结束文本\n\n\n\n',
//                     flex: '1',
//                     size: 16,
//                     align: 'CENTER',
//                     bold: true
//                   }
//                 ]
//               },
//               (res) => {
//                 console.log('-打印成功没得', res);
//               }
//             );
//           }
//         });
//       }
//     });
//   } catch (e) {
//     console.error('芯烨打印失败', e)
//     uni.showToast({ title: '打印失败，请检查芯烨打印机连接', icon: 'none' })
//   }
// }
